import React from 'react';
import { XIcon } from 'lucide-react';
import { recognizeItems } from '../data/content';
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-154" data-mp="30yj6zzn1oi5j">
      <div className="mx-auto max-w-4xl" data-id="element-155" data-mp="2w5ycevwbe10y">
        <div className="text-center" data-id="element-156" data-mp="2w4x24tn4hika">
          <h2 className="font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-157" data-mp="2r7eo4ou90d5f">
            <span aria-hidden="true" data-id="element-158" data-mp="2m8tqmx6ds7ko">📐 </span>Ti riconosci in queste{' '}
            <span className="italic text-grape" data-id="element-159" data-mp="2i6qc1zof0mv6">situazioni?</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-sm text-navy/55" data-id="element-160" data-mp="2i8tcldn71ye5">
            Se rispondi «sì» a una di queste domande, Matematica Pronta è stato
            creato apposta per te:
          </p>
        </div>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-161" data-mp="28avkgf27rhg9">
          {recognizeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white px-5 py-5 shadow-[0_2px_10px_-6px_rgba(22,56,111,0.25)]" data-id="element-162" data-mp="6h65dz0qc3hp">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-tangerine" aria-hidden="true" data-id="element-163" data-mp="3jn6m2knmtt7u" />
              <span className="text-sm font-medium leading-snug text-navy/75" data-id="element-164" data-mp="39nfna6s1gs1y">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-xl text-center font-display text-lg font-bold italic text-grape sm:text-xl" data-id="element-165" data-mp="3eo3gmz3qpkzc">
          Ti meriti molto di più di tutto questo. La tua passione merita ordine
          e facilità.
        </p>
      </div>
    </section>;
}